import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { FullWidthText, Statement } from '@/customTypes/chatStory';
import TextWithEffect from './TextWithEffect';

interface IFullWidthText {
  statement: Statement;
}

const FullWidthTextItem = ({ statement }: IFullWidthText) => {
  const fullWidthText: FullWidthText = statement;
  // const borderStyle = `border: 1px solid ${fullWidthText?.effect?.edgeColor}`;
  return (
    <div
      css={css`
        ${script}
        background-color: ${fullWidthText?.effect?.backgroundColor};
      `}
    >
      <TextWithEffect fullWidthText={fullWidthText} />
    </div>
  );
};

const script = `
  text-align: left;
  font-size: 1em;
  color: ${theme.colors.gray700};
  padding: 1em;
  white-space: pre-line;
  border: none;
`;

export default FullWidthTextItem;
